<template>
  <div class="main-body">
    <div class="header">点单统计</div>
    <div class="out">

      <div class="search2">
        <el-button size="mini" type="primary" plain @click.native="showChartsDialog=!showChartsDialog">图表展示</el-button>

        <div style="float:right;">
          <el-date-picker
              v-model="month"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月">
          </el-date-picker>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>


        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="活动内容" fixed></el-table-column>
        <el-table-column prop="count" label="次数" fixed></el-table-column>

      </el-table>


    </div>

    <el-dialog :visible.sync="showChartsDialog">
      <ve-pie :data="{
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['name', 'count'],
        rows: tableData
      }"></ve-pie>
    </el-dialog>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",

  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,


      th:0,

      month:'',
      showChartsDialog:false

    }
  },
  created(){

    this.th = this.$store.state.tableHeight+50;

    var date=new Date()
    var month=date .getFullYear() + "-" + date .getMonth()
    if(date .getMonth()==0){
      month=date .getFullYear()-1 + "-" + 12
    }
    this.month=month;

    this.getList();

  },
  components:{

  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+50;
    },
  },
  methods:{

    timefilter(row,index,column){
      return timefilters(column).slice(0,16)
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/TotalForCenter',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          month:this.month,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },


  }
}
</script>

